// extracted by mini-css-extract-plugin
export default {"container":"Styles_container__lyNLu","tagsContainer":"Styles_tagsContainer__VsM80","clearIcon":"Styles_clearIcon__h5QCH","popover":"Styles_popover__fLhFo"};